const carouselItems = [
  {
    title: '科幻纪元：未来世界电影回顾',
    desc: '从《2001太空漫游》到《流浪地球3》，探索科幻电影半个世纪的视觉进化与思想深度，感受科技与人文交织的光影传奇。',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20art%20featuring%20futuristic%20space%20elements%20with%20warm%20golden%20light%20streaks%2C%20deep%20crimson%20accents%2C%20luxurious%20theater%20atmosphere%2C%20dramatic%20contrast%2C%20film%20reel%20texture%20subtle%2C%20no%20text%2C%20elegant%20moody%20ambiance&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '国产动画崛起之路',
    desc: '从《大圣归来》到《深海》，中国动画人用匠心与技术突破边界，打造属于东方的视觉美学与动人故事，国产动画的黄金时代已经到来。',
    tag: '深度盘点',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20art%20with%20Chinese%20ink%20painting%20style%20elements%20and%20warm%20golden%20light%2C%20deep%20crimson%20accents%2C%20luxurious%20theater%20atmosphere%2C%20dramatic%20contrast%2C%20no%20text%2C%20elegant%20moody%20ambiance&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '诺兰电影宇宙：时间的魔术师',
    desc: '从《记忆碎片》到《奥本海默》，克里斯托弗·诺兰用非线性叙事和实拍奇观重新定义商业电影，每一部都是影迷必看的烧脑盛宴。',
    tag: '导演专题',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20art%20with%20clock%20and%20time%20motifs%20and%20warm%20golden%20light%20streaks%2C%20deep%20crimson%20accents%2C%20luxurious%20theater%20atmosphere%2C%20no%20text%2C%20elegant%20moody%20ambiance&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '暑期档必看十大佳片推荐',
    desc: '今年暑期档佳作频出，动作、喜剧、科幻、动画百花齐放，我们精选了十部口碑与票房双丰收的影片，陪你度过完美夏天。',
    tag: '观影指南',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20art%20with%20summer%20vibrant%20warm%20golden%20light%2C%20deep%20crimson%20accents%2C%20luxurious%20theater%20atmosphere%2C%20dramatic%20contrast%2C%20no%20text%2C%20elegant%20moody%20ambiance&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '经典港片修复计划：重温黄金时代',
    desc: '一批经过4K修复的经典港片登陆平台，从《英雄本色》到《无间道》，高清画质重现港片黄金年代的独特魅力与江湖情怀。',
    tag: '经典重现',
    img: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20art%20with%20Hong%20Kong%20neon%20street%20vibe%20and%20warm%20golden%20light%2C%20deep%20crimson%20accents%2C%20luxurious%20theater%20atmosphere%2C%20dramatic%20contrast%2C%20no%20text%2C%20elegant%20moody%20ambiance&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">焦点专题</h2>
          <p className="text-foreground-500 text-sm mt-2">深度内容，挖掘电影背后的故事</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group flex flex-col bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <span className="inline-block self-start px-2.5 py-1 bg-primary-500/15 text-primary-400 text-xs font-medium rounded-full mb-3">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-foreground-600 text-xs md:text-sm leading-relaxed flex-1">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center text-primary-400 text-xs font-medium">
                  <span>浏览专题</span>
                  <i className="ri-arrow-right-line ml-1"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}